import { MutationTuple, OperationVariables } from '@apollo/client';
import { getApolloLink, useApolloMutation, useCookie } from '@netfront/common-library';

import { IUseEkardoMutationInputVariables } from './useEkardoMutation.interfaces';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useEkardoMutation = <TData = any, TVariables = OperationVariables>({
  apolloLink,
  mutation,
  options,
  product,
  token,
}: IUseEkardoMutationInputVariables<TData, TVariables>): MutationTuple<TData, TVariables> => {
  const { getAccessTokenCookie, getTemporaryTokenCookie } = useCookie();

  const accessToken = getAccessTokenCookie();
  const temporaryToken = getTemporaryTokenCookie();

  const authenticationLink = getApolloLink({
    apiName: 'ekardo',
    product,
    token: token ?? accessToken ?? temporaryToken,
  });

  return useApolloMutation({
    apiName: 'ekardo',
    apolloLink: apolloLink ?? authenticationLink,
    mutation,
    options,
  });
};

export { useEkardoMutation };
